import React from 'react';
import PropTypes from 'prop-types';

import SrLink from 'client/components/SrLink/SrLink';

const SrPartnerBackButton = ({ partner }) => (
  <SrLink
    to={partner ? `/partner/${partner.slug}` : '/partner'}
    redirectToLastLocation
    className="controlButton backButton"
    restoreScrollPosition
  >
    Back
  </SrLink>
);

SrPartnerBackButton.propTypes = {
  partner: PropTypes.object,
};

SrPartnerBackButton.displayName = 'SrPartnerBackButton';

export default SrPartnerBackButton;
